import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BlogServiceService } from 'src/app/admin/services/blog/blog-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
    selector: 'app-edit-blog-category',
    templateUrl: './edit-blog-category.component.html',
    styleUrls: ['./edit-blog-category.component.scss'],
    standalone: false
})
export class EditBlogCategoryComponent implements OnInit {

  constructor(
    private userdata: UserdataService,
    private spinner: NgxSpinnerService,
    private blogService: BlogServiceService,
    private router: ActivatedRoute,
    private toast: ToastrService,
    private route: Router,
  ) { }

  data: any = '';
  id: any = '';


  ngOnInit(): void {
    this.id = this.router.snapshot.paramMap.get('id')
    this.getDataById()
  }

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    _id: new UntypedFormControl('', Validators.required),
    categoryname: new UntypedFormControl('', Validators.required),
    categorydescription: new UntypedFormControl('', Validators.required),
    category_slug: new UntypedFormControl('', [Validators.required,Validators.pattern('^[a-z0-9A-Z]+(?:-[a-z0-9A-Z]+)*$')]),
    updatedId: new UntypedFormControl('', [Validators.required]),
    category_keyword: new UntypedFormControl('', Validators.required),
  });


  getDataById() {
    this.spinner.show()
    this.blogService.getSingleBlogCategory({ _id: this.id}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.formGroup.patchValue({ _id: res.data._id });
        this.formGroup.patchValue({ categoryname: res.data.categoryname });
        this.formGroup.patchValue({ categorydescription: res.data.categorydescription });
        this.formGroup.patchValue({ category_slug: (res.data.category_slug).toLowerCase() });
        this.formGroup.patchValue({ updatedId: this.userdata.getId() });
        this.formGroup.patchValue({ category_keyword: res.data.category_keyword });
        this.f
      },
      err => {
        this.spinner.hide()
        this.route.navigateByUrl('/admin/blog-category/list')
      }
    )
  }

  get f() {
    return this.formGroup.controls
  }

  /* ***********
  Update Blog Category
 *********** */

  public updateBlogCategory() {
    // if(this.formGroup.get('remedy_link')?.value=='' && this.formGroup.get('updatedId')?.value==''){
    //   this.toast.error('Select Remedy Link or Suggested Astrologer')
    //   return
    // }
    this.spinner.show();
    this.blogService.updateBlogCategory(this.formGroup.value).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.toast.success(res.message, 'Success');
        this.route.navigateByUrl('/admin/blog-category/list')
      },
      err => {
        this.spinner.hide()
        this.toast.error('Something went wrong!', 'Error');
      })
  }

}
